import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../../mfe/MfeLoader";
import { getIntegrationsHostConfig } from "../../config/integrationsHostConfig";
import { useHostNavigate } from "../../hooks/useHostNavigate";

export const Route = createFileRoute("/integrations/$")({
  component: IntegrationsCatchAll,
});

function IntegrationsCatchAll() {
  const onNavigate = useHostNavigate();
  return (
    <MfeLoader
      name="integrations"
      props={{ hostConfig: getIntegrationsHostConfig(onNavigate) }}
    />
  );
}
